module.exports = __webpack_public_path__ + "static/media/login_back_icon.aff010c1.svg";